import React from 'react';

/**
 * Dedicated dashboard presets were removed. Orphan preset_* widgets from old
 * configs show this placeholder so the rest of the report still loads.
 */
export default function PresetWidget({ widget }) {
  return (
    <div className="flex h-full items-center justify-center p-4 text-center text-sm text-slate-400">
      ویجت پیش‌فرض «{widget?.type || '—'}» حذف شده است. همین بخش را با کارت KPI، جدول یا نمودار بسازید.
    </div>
  );
}
